export default __webpack_public_path__ + "static/media/projectimg1.f025a5d6.png";